<template>
    <form>
      <div class="p-fluid">
        <div class="p-field">
           <div>

            <p class="c14">親愛的供應商您好:</p>
            <p class="c12">當您開始使用仁寶供應商整合平台系統(以下簡稱「VIP系統」)，即表示您已閱讀、了解並同意接受VIP系統所有內容與注意事項。</p>
              <p class="c12">
                仁寶有權隨時調整VIP系統相關條款與注意事項、或新增、刪減、關閉VIP系統一部或全部功能，並將於VIP系統上進行公告。您應隨時注意VIP系統上之公告說明，仁寶將不另行通知。
              </p>
<h3 class="c14R">◎	注意事項:</h3>
<ol>
  <li><p class="c12">
      請您謹慎並真實填寫相關資料。如有任何隱匿、遺漏或不為說明之情形，仁寶有權取消您以及貴公司的所有帳號。
      </p>
  </li>
  <li><p class="c12">
    您知悉並同意，仁寶不承擔任何的帳號密碼保管責任，請您自行保管帳號密碼並定期更新密碼，並且該帳號密碼不得對外揭露。
      </p>
  </li>
  <li><p class="c12">
    您知悉並同意，於申請Supervisor帳號後，該帳號為與仁寶VIP系統聯絡窗口及公司帳號管理員，應負責管理及申請新增系統及USER帳號申請。VIP 設定的 Supervisor 和 User 的責任義務須將仁寶的相關訊息能夠有效且準確地在公司內部傳達。
      </p>
  </li>
  <li><p class="c12">
    您不得提供帳號密碼予非公司人員使用，否則仁寶有權取消您以及貴公司的所有帳號。
      </p>
  </li>
  <li><p class="c12">
    VIP系統的所有資料、技術(包含技術支援以及軟體等)及服務等所有權以及相關智慧財產權均屬於仁寶。貴公司不得以任何方式直接或間接拷貝、複製、修改、翻譯、改編、洩漏、授權、出租、傳播、轉讓、許可或以任何方式提供他人使用上述資源。如有違反，仁寶除得取消您以及貴公司的所有帳號，貴公司應承擔相應的法律責任並賠償仁寶因此所受之所有損失。

      </p>
  </li>
  <li><p class="c12">
    如果仁寶合理確信您的任何使用符合以下條件，仁寶有權取消您以及貴公司的所有帳號權利：
  (1) 違反VIP系統相關條款與注意事項；
  (2) 違反適用法律；或 
  (3) 對仁寶或可能對仁寶造成傷害。
      </p>
  </li>
</ol>

 


           </div>
         <hr/>  
<div>
  <p class="c14RE">Terms and Conditions</p>
  <p class="c12E">Dear suppliers,</p>
  
  <p class="c12E">
    When you start using Compal Vendor Integration Portal system (hereinafter referred to as the ‘VIP system’), it indicates that you have read, understood, and agreed to accept all the contents and precautions of the VIP system.
   </p>
  <p class="c12E">
    Compal reserves the right to update, modify, or change any terms and precautions related to the VIP system at any time, as well as to close all or any part of the VIP system’s functions. Any such changes will be announced on the VIP system. You should always pay attention to the announcements on the VIP system as Compal will not notify separately.
  </p>

<h3 class="c14RE">◎	Notes: </h3>

<ol>
  <li>
    <p class="c12E">
      Please fill in the relevant information carefully and truthfully. If there is any concealment, omission, or failure to provide explanations, Compal reserves the right to cancel all your and your company's accounts.
       </p>
  </li>
  <li>
    <p class="c12E">
      You acknowledge and agree that Compal assumes no responsibility for the custody of your account and password. Please ensure to keep your account and password secure, updating your password regularly, and refrain from disclosing the account and password to any third party.   </p>
  </li>
  <li>
    <p class="c12E">
      You acknowledge and agree that upon applying for a Supervisor account, the Supervisor account will serve as the primary contact window with the Compal VIP system and the company account administrator. Additionally, the Supervisor shall be responsible for managing and initiating applications for new systems and USER account requests. It's the responsibility of Supervisors and Users to ensure that relevant information about Compal is effectively and accurately conveyed within the company. </p>
  </li>
  <li>
    <p class="c12E">
      You are prohibited from sharing your account and password with non-company personnel. Failure to comply may result in Compal exercising its right to cancel all your and your company's accounts.     </p>
  </li>
  <li>
    <p class="c12E">
      All data, technology (including technical support and software, etc.), and services of the VIP system, along with related intellectual property rights, shall belong to Compal. Your company may not copy, reproduce, modify, translate, adapt, leak, authorize, rent, disseminate, transfer, license, or in any way provide others with the use of the above resources. Any violation of the policy will result in Compal canceling all of your and your company's accounts, and your company will bear corresponding legal liability and compensate Compal for all losses incurred as a result.    </p>
  </li>
  <li>
    <p class="c12E">
      If Compal reasonably believes that any of your actions constitute any of the following, Compal reserves the right to cancel all account rights of you and your company: (1) a breach of the relevant terms and precautions of the VIP system; (2) a violation of applicable laws; or (3) actions that cause or may cause harm to Compal.
       </p>
  </li>
</ol>

     
</div>

        </div>
      </div>
      
      
      <div class="row">
        <div class="col-6"></div>
        <div class="col-3">
          <Button
            label="I Agree"
            icon="pi pi-check"
            class="btn btn-success" 
            @click="agree()"
          />
        </div>
        <div class="col-3">
          <Button
            label="I don't agree"
            icon="pi pi-times"
            class="btn btn-danger" 
            @click="closeModal()"
          />
        </div>
        
      </div>
    </form>
  </template>
  
  
  <script>
   export default {
    data() {
      return {
       
      };
    },
    created() {
     
    },
    methods: {
      closeModal() {
        this.$emit("close");
    
      },
      agree() {
        this.$emit("agree");
      },
    },
  };
  </script>
  <style scoped>
  .c14{
    font-family: "標楷體";
    font-size: 14pt;
  }
  .c14R{
    font-family: "標楷體";
    font-size: 14pt;
    color:red;
    font-weight:bold;
  }
  .c12{
    font-family: "標楷體";
    font-size: 12pt;
  }

  .c14RE{
    font-family: "Times New Roman";
    font-size: 14pt;
    color:red;
    font-weight:bold;
  }
  
  .c12E{
    font-family: "Times New Roman";
    font-size: 12pt;
  }
  .p-dialog-title {
    color: red!important;
}
  </style>